<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Categorias",
            items: [
                {
                    text: "Inicio",
                    href: "/"
                },
                {
                    text: "categorias",
                    active: true
                }
            ],
            categorias:{},
            categoria:null,
            isLoading:false,
            datos:{
                name:'',
                categoriaP_id:''
            }
        };
    },
    methods: {
        get_data(){
            this.isLoading=true
            try {
                axios.get('/api/categorias').then(res=>{
                    this.categorias = res.data.datos;
                    this.$toasted.success('Datos cargados!');
                })  
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading=false
            }
        },
        agregar(){
            this.isLoading=true
            axios.post('/api/categorias',this.datos).then(res=>{
                if(res.data.estado){
                    this.categoria = res.data.categoria;
                    this.datos.name=''
                    this.get_data()
                }else{
                    alert('error al agregar')
                }
                this.isLoading=false
            })
        },
        eliminar(id){
            this.isLoading=true
            axios.delete('/api/categorias/'+id).then(res=>{
                this.categorias = res.data.datos;
                this.get_data()
                this.isLoading=false
            })
        },
    },
    mounted() {
        this.get_data()
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <table class="table">
                            <thead>
                                <th class="py-0 px-1">#</th>
                                <th class="py-0 px-1">NOMBRE</th>
                                <!-- <th class="py-0 px-1">CATEGORIA PADRE</th> -->
                                <th class="py-0 px-1"></th>
                            </thead>
                            <tbody>
                                <tr v-for="(m, i) in categorias" :key="i">
                                    <td class="py-0 px-1">{{ i + 1 }}</td>
                                    <td class="py-0 px-1">{{ m.name }}</td>
                                    <!-- <td class="py-0 px-1">{{ m.categoria_padre!=null?m.categoria_padre.name:'' }}</td> -->
                                    <td class="py-0 px-1">
                                        <div class="btn-group">
                                            <a @click="eliminar(m.id)" class="btn btn-danger btn-sm py-1 px-2">
                                                <i class="fas fa-trash"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <div class="card">
                    <div class="card-body">
                        <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Nombre">
                            <b-form-input for="text" placeholder="Nombre" v-model="datos.name"  ></b-form-input>
                        </b-form-group>
                        <!-- <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Categoria Padre">
                            <!-a- <select class="custom-select" v-model="datos.categoriaP_id">
                                <option value="">Selecciona una categoría</option>
                                <optgroup v-for="(categoria,i) in categorias" :label="categoria.name" :key="i">
                                <option v-for="(subcategoria,ii) in categoria.subcategorias" :value="subcategoria.id" :key="ii">{{ subcategoria.name }}</option>
                                </optgroup>
                            </select> -a->
                            <select class="custom-select" v-model="datos.categoriaP_id">
                                <option value="">Selecciona una categoría</option>
                                <option v-for="(categoria,i) in categorias" :label="categoria.name" :value="categoria.id" :key="i"></option>
                            </select>
                            
                        </b-form-group> -->
                        <b-button v-show="datos.name!==''" block variant="success" @click="agregar()">Agregar</b-button>
                        <loading-message v-if="isLoading" />
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
